// Remove custom style var and sx prop
import { Trans, useTranslation } from 'react-i18next';

import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type LaunchSiteTypeModalPtopOptions = {
  open: boolean;
  showClose?: boolean;
  onClose?: VoidFunction;
};
const LaunchSiteTypeModal = ({
  open,
  showClose = false,
  onClose = undefined,
}: LaunchSiteTypeModalPtopOptions) => {
  useTranslation('launchSiteTypeModal');

  return (
    <Dialog
      open={open}
      {...(showClose && { onClose })}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogContent>
        <Stack spacing={2} marginBottom={4}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ p: 0, alignSelf: 'flex-end' }}
          >
            <CloseIcon />
          </IconButton>

          <Stack spacing={4} justifyContent="center" alignItems="center">
            <Typography variant="h2">
              <Trans
                i18nKey="launchSiteTypeModal:launchSiteType"
                values={{
                  siteType: 'your website',
                }}
              />
            </Typography>
            <Typography variant="body1">
              <CircularProgress />
            </Typography>
            <Typography variant="body2">
              <Trans
                i18nKey="launchSiteTypeModal:siteTypeLoading"
                values={{
                  siteType: 'your website',
                }}
              />
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default LaunchSiteTypeModal;
